import React from 'react';
import SelectionGroupBase from './SelectionGroupBase';
import { Checkbox } from '../SelectionInput';
import { TCheckbox } from '../SelectionInput/Checkbox';

type TCheckboxSelectionGroup = {
  errorText?: string;
  onChange: (values: string[]) => void;
  values: string[];
  // onChange and isChecked will be calculated by the SelectionGroup, all other checkbox props are valid
  options: Array<Omit<TCheckbox, 'onChange' | 'isChecked'>>;
};

const CheckboxSelectionGroup = ({ options, values, errorText, onChange }: TCheckboxSelectionGroup) => {
  const handleChange = (value) => {
    let newValues;
    if (values.includes(value)) {
      // remove value from values
      newValues = values.filter((val) => val !== value);
    } else {
      // add value to values
      newValues = [...values, value];
    }
    onChange(newValues);
  };
  return (
    <SelectionGroupBase errorText={errorText}>
      {options.map((option) => (
        <Checkbox
          {...option}
          id={option.id || `checkbox-option-${option.labelText}-${option.value}`}
          key={option.id || `checkbox-option-${option.labelText}-${option.value}`}
          isChecked={values.includes(option.value)}
          onChange={() => handleChange(option.value)}
        />
      ))}
    </SelectionGroupBase>
  );
};

export default CheckboxSelectionGroup;
